import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {KalturaConfig} from '../kaltura/kaltura-config';

@Component({
  selector: 'app-kaltura-asset-player',
  templateUrl: './kaltura-asset-player.component.html',
  styleUrls: ['./kaltura-asset-player.component.scss']
})
export class KalturaAssetPlayerComponent implements OnInit {

  @Input() playerId: number;
  @Input() assetId: string;
  @Output() played: EventEmitter<boolean> = new EventEmitter<boolean>();

  config: KalturaConfig;
  targetId: string;
  playerIdStr: string;

  constructor() {
  }

  ngOnInit() {
    this.playerIdStr = String(this.playerId);
    this.targetId = null;
    this.config = new KalturaConfig(environment.kaltura.partnerId, environment.kaltura.playerId);
  }

  onReady(targetId: string) {

  }

  onPlay($event: boolean) {
    if ($event) {
      this.played.emit(true);
    }
  }
}
